import { Button } from "design-system/atoms/Button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "design-system/atoms/Dialog"
import { Tooltip, TooltipContent, TooltipTrigger } from "design-system/atoms/Tooltip"
import { Download } from "lucide-react"
import { useAuthEmployeeQuery } from "modules/auth/hooks/useAuthEmployeeQuery"
import { useExportTableMutation } from "modules/shared/hooks/useExportTableMutation"
import { useState } from "react"
import { Trans, useTranslation } from "react-i18next"
import { ExporterBodySchema } from "schema"
import { toast } from "sonner"
import z from "zod"

type Props = z.infer<typeof ExporterBodySchema>

export const ExportTable = (props: Props) => {
  const { t } = useTranslation()
  const { data: employeeData } = useAuthEmployeeQuery()
  const [isOpen, setIsOpen] = useState(false)
  const { mutateAsync, isPending } = useExportTableMutation()

  const onDownload = async () => {
    await mutateAsync(props)

    setIsOpen(false)
    toast.success(t("shared.exportTable.success"))
  }

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <Tooltip>
        <DialogTrigger asChild>
          <TooltipTrigger asChild>
            <Button
              size={"icon"}
              variant={"outline"}
              className="w-10 h-10"
              // title={t("shared.exportTable.trigger")}
            >
              <Download />
            </Button>
          </TooltipTrigger>
        </DialogTrigger>
        <TooltipContent>{t("shared.exportTable.trigger")}</TooltipContent>
      </Tooltip>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("shared.exportTable.title")}</DialogTitle>
          <DialogDescription className="whitespace-pre-line">
            <Trans
              i18nKey={"shared.exportTable.description"}
              values={{ email: employeeData?.adminEmail ?? employeeData?.email }}
              components={{ b: <span className="text-foreground font-medium" /> }}
            />
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-center">
          <Button disabled={isPending} onClick={onDownload} variant={"outline"}>
            {t("shared.exportTable.generate")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
